module.exports = {
  IN: '₹',
  LK: 'Rs.',
  BG: '৳'
}
